module.exports = __webpack_public_path__ + "static/media/settings.958a3b71.svg";